import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getUserInformation } from "../actions/userActions";
import ProfileNavbar from "../components/Profile_Components/ProfileNavbar";
import ProfileInformation from "../components/Profile_Components/ProfileInformation";
import BreadcrumbLocation from "../components/BreadcrumbLocation";
const ProfileInformationScreen = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const userLogin = useSelector((state) => state.userLogin);
  const { loading, isAuthenticated, error, token, name } = userLogin;
  useEffect(() => {
    if (isAuthenticated === false) {
      navigate(`/login?redirect=${location.pathname}`);
    }
    if (isAuthenticated === true) {
      dispatch(getUserInformation());
    }
  }, [isAuthenticated]);
  return (
    <>
      <BreadcrumbLocation
        location={["ReShup", "Settings", "Edit Profile"]}
      ></BreadcrumbLocation>
      <div className="container d-flex flex-row mt-4">
        <ProfileNavbar name={name}></ProfileNavbar>

        <ProfileInformation></ProfileInformation>
      </div>
    </>
  );
};

export default ProfileInformationScreen;
